module.exports = __webpack_public_path__ + "static/CarreiraProfissional-5a1b4d37fd65e71e12b4aed14118ba19.svg";